// Canvas-side postMessage endpoint. Lets peer Symbols origins iframe
// this page and read the SDK tokens held in canvas's localStorage so a
// user signed in on canvas doesn't have to sign in again on workspace /
// marketplace / preview. Whitelisted origins only; page has no UI.

import { collectSdkTokens, collectSupabaseSessions } from '../../shared/governanceBridge.js'

const ALLOWED_ORIGIN_PATTERNS = [
  /^https?:\/\/workspace\.localhost(:\d+)?$/,
  /^https?:\/\/system-governance-intranet\.localhost(:\d+)?$/,
  /^https?:\/\/governance-intranet\.localhost(:\d+)?$/,
  /^https?:\/\/marketplace\.localhost(:\d+)?$/,
  /^https?:\/\/preview\.localhost(:\d+)?$/,
  /^https?:\/\/[^.]+\.symbols\.app$/
]

const isAllowedOrigin = (origin) =>
  ALLOWED_ORIGIN_PATTERNS.some((re) => re.test(origin))

export const sessionBridge = {
  metadata: { title: 'Session bridge · Symbols' },
  background: '#0f1116',
  color: 'rgba(255,255,255,0.35)',
  fontFamily: 'system-ui',
  fontSize: 'Z2',
  padding: 'A',
  text: 'Session bridge. Hands off the canvas session to other Symbols subdomains.',

  onRender: (el) => {
    if (el.__bridgeInit) return
    el.__bridgeInit = true

    window.addEventListener('message', (ev) => {
      if (!isAllowedOrigin(ev.origin)) return
      if (ev.data?.type !== 'symbols-session-request') return
      const sdkTokens = collectSdkTokens() || {}
      const supabaseSessions = collectSupabaseSessions() || {}
      const hasSdk = !!sdkTokens.symbols_access_token ||
        !!sdkTokens.symbols_bridge_access_token
      const hasSb = Object.keys(supabaseSessions).length > 0
      ev.source?.postMessage(
        hasSdk || hasSb
          ? { type: 'symbols-session-response', ok: true, sdkTokens, supabaseSessions }
          : { type: 'symbols-session-response', ok: false, error: 'no-session' },
        ev.origin
      )
    })

    // Parent waits for this before sending its request so the
    // handshake can't race a listener that armed after postMessage.
    try {
      if (window.parent && window.parent !== window) {
        window.parent.postMessage({ type: 'symbols-session-ready' }, '*')
      }
    } catch {}
  }
}
